import { combineReducers } from 'redux'

// NOTE: add component
// import temp from './_temp'
import device from './device'
import talk from './talk'
import questions from './questions'
import result from './result'
import modal from './modal'
import cookie from './cookie'
import status from './status'
import urlquery from './urlquery'
import campaignShopList from './campaignShopList'

const reducer = combineReducers({
  // temp,
  device,
  talk,
  questions,
  result,
  modal,
  cookie,
  status,
  urlquery,
  campaignShopList,
})

export default reducer
